/*!
 * Developed by Markant
 */
/**
 * Checks if the given element has at least one child node at the given slot
 * @param element The element which has a named slot inside
 * @param name The name of the slot to check
 * @return `true` if a child at the slot exists, otherwise `false`
 */
function hasNamedSlot(element, ...names) {
    for (const nameOrNames of names) {
        const slotNames = Array.isArray(nameOrNames) ? nameOrNames : [nameOrNames];
        for (const name of slotNames) {
            if (hasSingleNamedSlot(element, name)) {
                return true;
            }
        }
    }
    return false;
}
function hasSingleNamedSlot(element, name) {
    return element.querySelectorAll(`[slot=${name}]`).length > 0;
}
function getSlotContent(element, ...names) {
    for (const nameOrNames of names) {
        const slotNames = Array.isArray(nameOrNames) ? nameOrNames : [nameOrNames];
        for (const name of slotNames) {
            const slotContent = element.querySelector(`[slot="${name}"]`);
            if (slotContent) {
                return slotContent;
            }
        }
    }
    return null;
}

export { getSlotContent as g, hasNamedSlot as h };
